<script>
import OrganizationsFilters from '@organizations/components/organizations-filters.vue'
import Layout from '@layouts/loggedin.vue'
import { authComputed } from '@state/helpers'
import AdminTable from '@components/admin-table.vue'
import { ORGANIZATIONS_TABLE_FIELDS } from '@organizations/constant'

export default {
  name: 'OrganizationsList',
  components: { Layout, OrganizationsFilters, AdminTable },
  data() {
    return {
      tableFields: ORGANIZATIONS_TABLE_FIELDS,
    }
  },
  computed: {
    ...authComputed,
    page() {
      return this.$store.state.organizations.page || 1
    },
    perPage() {
      return this.$store.state.organizations.perPage || 10
    },
    lists() {
      return this.$store.state.organizations.filteredOrganizations || []
    },
    total() {
      return this.$store.state.organizations.total || 0
    },
    loaded() {
      return this.$store.state.organizations.loaded || false
    },
  },
  methods: {
    setPage(params) {
      this.$store.dispatch('organizations/setPage', params)
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bg-white">
      <div class="flex justify-between pl-10 pr-12 pt-4 pb-4">
        <div class="">
          <div class="inline-block align-middle">
            <h2 class="text-black text-xl">Nonprofit Organizations</h2>
          </div>
        </div>
      </div>

      <OrganizationsFilters />

      <div class="flex justify-between pl-10 pr-12 mt-3 h-14 leading-14">
        <div class="flex">
          <BaseLink
            name="organizationsList"
            class="events-tab"
            active-class="active"
            append
            exact
          >
            Discover
          </BaseLink>
        </div>
      </div>
    </div>

    <div class="pt-4 px-8 pb-12 mb-16">
      <div class="bg-white p-4 rounded-lg shadow-md">
        <AdminTable
          table-type="ORGANIZATIONS"
          :table-fields="tableFields"
          :total-num="total"
          :list-data="lists"
          :data-loaded="loaded"
          :cur-page="page"
          :per-page="perPage"
          :no-new-btn="true"
          :no-filter-option="true"
          :no-edit-btn="true"
          :no-total-label="true"
          :hide-search-bar="true"
          @table-set-page="setPage"
        />
      </div>
    </div>
  </Layout>
</template>
